












import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { InquiryKind } from '@ajax/modules/services/inquiry'
import ArrivalNotification from '@ajax/vue/components/organisms/ArrivalNotification.vue'

@Component({
  components: {
    ArrivalNotification,
  },
})
export default class Newstock extends Vue {
  @Prop()
  id: string

  @Prop({ required: true })
  brandEnglishName: string

  /** 表示後に遅延して情報を取得するのでnullable */
  @Prop({ required: true })
  isLineAccountAssociated: boolean | null

  @Prop({ default: false })
  lineAssociationLoadError: boolean

  @Prop({ default: false })
  useLargeButton: boolean

  get inquiryKind(): InquiryKind {
    return 'new_stock'
  }
}
